// extracted by mini-css-extract-plugin
module.exports = {"head":"Head_head__1W1Gr","inner":"Head_inner__32F6W","close":"Head_close__2GRtE","actions":"Head_actions__3nzKQ","btn":"Head_btn__3at4K","abtn":"Head_abtn__3APVQ"};